import FACTORY, { factoryModel } from '../../../../FACTORY/FACTORY.js';
import COLUMN from '../../../../DOM/table/TGROUP/ROW/column/COLUMN.js';
import TD from '../../../../DOM/table/TGROUP/ROW/column/TD.js';
import TH from '../../../../DOM/table/TGROUP/ROW/column/TH.js';
/** A Table Row Column Factory */
export default class COLUMNFACTORY extends FACTORY {
    /** Represents the location where children of this factory are instantiated */
    surrogate;
    constructor(model, surrogate) {
        super(model);
        this.surrogate = surrogate;
        this.addConstructor('TD', (model) => this.surrogate.addChild(new TD(this.surrogate, model)));
        this.addConstructor('TH', (model) => this.surrogate.addChild(new TH(this.surrogate, model)));
    }
}
export { COLUMN, factoryModel };
